/**
 * What a publish did, in a sentence.
 *
 * A publish can go out under a different revision from the one asked for (ADR-S-054): when a bound
 * dictionary or violation message changed since a revision went out, the server copies it forward,
 * because the agent ignores new bytes under a number it already holds. Saying "revision 2 published"
 * after a click on revision 1 would read as a mistake, so the sentence says where the number came from.
 */
export function publishedRevision(revision: number | null | undefined, revisedFrom?: number | null): string {
  if (revisedFrom != null && revision != null && revision !== revisedFrom)
    return (
      `revision ${revision} published, a copy of revision ${revisedFrom}. Its words or rules changed since ` +
      `revision ${revisedFrom} went out, and devices take new contents only under a new revision`
    )
  return `revision ${revision ?? '?'} published`
}
